import * as actionTypes from '../actions';

const initialState = {
    autoRefreshError: null, 
};

const autoRefreshReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.AUTOREFRESH_SUCCESS:
            return {
                ...state,
                autoRefreshError: null,
            };
        case actionTypes.AUTOREFRESH_ERROR:
            return {
                ...state,
                autoRefreshError: action.error,
            }
        case actionTypes.AUTOREFRESH_REQUEST:
        default:
            return state;
    }
};

export default autoRefreshReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/autoRefresh.js